import { LearningBudgetService } from '@/services/learning-budget';
import { ApiReactQueryOptions } from '@/types/api';
import { ILearningBudgetTransactionFilters } from '@/types/learning-budget';
import { useQuery } from '@tanstack/react-query';

export function useLearningBudgetTransactionsExport(
  filters?: ILearningBudgetTransactionFilters,
  options?: ApiReactQueryOptions<Response>,
) {
  return useQuery({
    queryKey: [LearningBudgetService.TRANSACTIONS_EXPORT_PATH, filters],
    queryFn: async () => {
      return await LearningBudgetService.exportLearningBudgetTransactions({
        ...filters,
      });
    },
    ...options,
  });
}
